const ACTIVE_ORDER_PATTERN = /ya hay una orden activa en esta línea:\s*(\S+)/i

export function parseActiveOrderNumber(errorMessage) {
  if (!errorMessage) return null
  const match = String(errorMessage).match(ACTIVE_ORDER_PATTERN)
  return match?.[1] ?? null
}

/**
 * Mensaje amigable cuando el backend indica conflicto por orden activa en la línea.
 * @returns {string|null} Mensaje formateado, o null si no aplica.
 */
export function formatActiveOrderConflictMessage(errorMessage) {
  if (!errorMessage || !String(errorMessage).includes('ya hay una orden activa')) {
    return null
  }

  const activeOrderNumber = parseActiveOrderNumber(errorMessage)
  const orderLabel = activeOrderNumber
    ? `la orden ${activeOrderNumber}`
    : 'una orden'

  return (
    `No se puede iniciar: ya hay ${orderLabel} activa en esta línea. ` +
    'Debes finalizar primero la orden actual con el botón "Fin OF" antes de iniciar otra.'
  )
}

export function resolveStartOrderErrorMessage(error, fallback = 'Error al iniciar la orden') {
  const errMsg = error?.response?.data?.message || error?.message || ''
  return formatActiveOrderConflictMessage(errMsg) || errMsg || fallback
}
